import type { FC } from 'react'

import type { TIconProps } from 'types'

const ArrowIconRightLong: FC<TIconProps> = ({ className }) => (
    <svg className={className} width='13' height='10' viewBox='0 0 13 10' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M7.4093 8.57613C7.17498 8.81044 7.17498 9.19034 7.4093 9.42465C7.64361 9.65897 8.02351 9.65897 8.25782 9.42465L12.2578 5.42465C12.3703 5.31213 12.4336 5.15952 12.4336 5.00039C12.4336 4.84126 12.3703 4.68865 12.2578 4.57613L8.25782 0.576127C8.02351 0.341812 7.64361 0.341812 7.4093 0.576127C7.17498 0.810441 7.17498 1.19034 7.4093 1.42466L10.385 4.40039H1.16689C0.835524 4.40039 0.566895 4.66902 0.566895 5.00039C0.566895 5.33176 0.835524 5.60039 1.16689 5.60039H10.385L7.4093 8.57613Z'
            fill='currentColor'
        />
    </svg>
)

export default ArrowIconRightLong